import {arrayShuffle} from '../../../../lib/helpers';
import {
  DndGapFillingState,
  DndGapState,
  GapFillingState,
  ItemPosition,
  KbtGapFillingState,
  KbtGapState,
  positionToItemId,
} from './classroom/models';
import {GapFillingModel} from './models';

function gapItemIds(model: GapFillingModel): string[] {
  const itemIds: string[] = [];

  for (let paragraphIndex = 0; paragraphIndex < model.paragraphs.length; paragraphIndex++) {
    let paragraph = model.paragraphs[paragraphIndex];
    for (let itemIndex = 0; itemIndex < paragraph.items.length; itemIndex++) {
      let item = paragraph.items[itemIndex];
      if (item.type !== 'gap')
        continue;
      const position: ItemPosition = {paragraph: paragraphIndex, index: itemIndex};
      const itemId = positionToItemId(position);
      itemIds.push(itemId);
    }
  }

  return itemIds;
}

function defaultDndItemState(): DndGapState {
  return {
    filledWith: null,
    checkCount: 0,
    checked: false
  };
}


function initialDndState(model: GapFillingModel): DndGapFillingState {
  const itemIds = gapItemIds(model);
  const itemStates: { [index: string]: DndGapState } = {};

  for (let itemId of itemIds)
    itemStates[itemId] = defaultDndItemState();

  arrayShuffle(itemIds);

  return {
    itemOrder: itemIds,
    states: itemStates
  };
}

/******************************************************************************/

function defaultKbtState(): KbtGapState {
  return {
    filledWith: '',
    checked: false,
    checkCount: 0
  };
}

function initialKbtState(model: GapFillingModel): KbtGapFillingState {
  const states: { [index: string]: KbtGapState } = {};

  const itemIds = gapItemIds(model);
  for (let itemId of itemIds)
    states[itemId] = defaultKbtState();

  return {states: states};
}

function initialState(model: GapFillingModel): GapFillingState {
  if (model.behavior === 'drag-and-drop')
    return initialDndState(model);
  if (model.behavior === 'keyboard-type')
    return initialKbtState(model);
  throw new Error('unexpected value for behavior ' + model.behavior);
}

class GapFillingUtilsClass {
  readonly initialState = initialState;
}

export const gapFillingUtils = new GapFillingUtilsClass();
